export * from './esports-slides.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/index.ts